<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">点单详情</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: url}">订单列表</el-breadcrumb-item>
                            <el-breadcrumb-item>点单详情</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-tabs v-model="currentTab" class="detail-tabs" type="orderdetail" @tab-click="handleClick">
                            <el-tab-pane label="按订单显示" name="2">
                                <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                                    <el-table-column prop="user_number" align="center" label="用户编号" min-width="160">
                                        <template slot-scope="scope">
                                            <span class="user-num-span" @click="$util.goTo('/user/list',{query:{user_number:scope.row.user_number}})">{{scope.row.user_number}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="nick_name" align="center" label="用户昵称" min-width="160">
                                    </el-table-column>
                                    <el-table-column prop="order_number" align="center" label="订单编号" min-width="180">
                                        <template slot-scope="scope">
                                            <my-textEllipsis v-if="is_refresh" :content="scope.row.order_number"></my-textEllipsis>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sub_order_number" align="center" label="子单编号" min-width="180">
                                        <template slot-scope="scope">
                                            <my-textEllipsis v-if="is_refresh" :content="scope.row.sub_order_number"></my-textEllipsis>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="c_time" align="center" label="下单时间" min-width="180">
                                    </el-table-column>
                                    <el-table-column prop="appointment_time" align="center" label="预定时间" min-width="140">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.appointment_time}} 预定</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sale_total_amount" align="center" label="订单总价" min-width="160">
                                    </el-table-column>
                                    <el-table-column prop="discount_total_amount" align="center" label="优惠金额" min-width="120">
                                        <template slot-scope="scope">
                                            <span class="c-red">{{scope.row.discount_total_amount}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="desk_name" align="center" label="下单店铺名称/店铺名称" min-width="200">
                                        <template slot-scope="scope">
                                            <my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name"></my-textEllipsis>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="order_mode==2" prop="consignee" align="center" label="联系人" min-width="120" fixed="right">
                                    </el-table-column>
                                    <el-table-column v-if="order_mode==2" prop="consignee_phone" align="center" label="联系电话" min-width="140" fixed="right">
                                    </el-table-column>
                                    <el-table-column v-if="order_mode==2" prop="consignee_addr" align="center" label="配送地址" min-width="160" fixed="right">
                                        <template slot-scope="scope">
                                            <my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name+scope.row.consignee_addr"></my-textEllipsis>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="order_mode==2" prop="pay_status_name" align="center" label="状态" min-width="120" fixed="right">
                                        <template slot-scope="scope">
                                            <span :class="'status-'+scope.row.pay_status">{{scope.row.pay_status_name}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="operating" align="right" label="操作" min-width="100" fixed="right">
                                        <template slot-scope="scope">
                                            <el-button v-if="status!=10" class="option-btn btn-bd-m" type="primary" size="mini" @click="goodsDetail(scope.row.user_number,scope.row.sub_order_number)">商品详情</el-button>
                                            <!--<el-button v-if="type==2" class="option-btn btn-bd-s" type="primary" size="mini" @click="printThis(scope.row.user_number)">打印小票</el-button>-->
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <el-tab-pane label="按用户显示" name="1" class="tab-item1">
                                <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                                    <el-table-column prop="user_number" align="center" label="用户编号" min-width="160">
                                        <template slot-scope="scope">
                                            <span class="user-num-span" @click="$util.goTo('/user/list',{query:{user_number:scope.row.user_number}})">{{scope.row.user_number}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="nick_name" align="center" label="用户昵称" min-width="160">
                                    </el-table-column>
                                    <el-table-column prop="appointment_time" align="center" label="预定时间" min-width="140">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.appointment_time}} 预定</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sale_total_amount" align="center" label="订单总价" min-width="160">
                                    </el-table-column>
                                    <el-table-column prop="discount_total_amount" align="center" label="优惠金额" min-width="120">
                                        <template slot-scope="scope">
                                            <span class="c-red">{{scope.row.discount_total_amount}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="paid_amount" align="center" label="订单实付" min-width="160">
                                    </el-table-column>
                                    <el-table-column prop="operating" align="right" label="操作" min-width="180" fixed="right">
                                        <template slot-scope="scope">
                                            <el-button v-if="status!=10" class="option-btn btn-bd-m" type="primary" size="mini" @click="goodsDetail(scope.row.user_number,1)">商品详情</el-button>
                                            <el-button v-if="type==2" class="option-btn btn-bd-s" type="primary" size="mini" @click="printThis(scope.row.user_number)">打印小票</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
                <el-dialog class="dialog-export activity-dialog" :title="dlg_goods.title" :visible.sync="dlg_goods.visible" width="800px" :close-on-click-modal="false">
                    <el-table ref="multipleTable" :data="dlg_goods.table_data.list" v-loading="dlg_goods.table_data.loading" max-height="600px" tooltip-effect="dark" style="width: 100%;text-align: center;">
                        <el-table-column prop="product_name" align="center" label="商品名称" min-width="180">
                            <template slot-scope="scope">
                                <my-textEllipsis v-if="is_refresh" :content="scope.row.product_name"></my-textEllipsis>
                            </template>
                        </el-table-column>
                        <el-table-column prop="product_intro" align="center" label="商品简介" min-width="200">
                            <template slot-scope="scope">
                                <my-textEllipsis v-if="is_refresh" :content="scope.row.product_intro"></my-textEllipsis>
                            </template>
                        </el-table-column>
                        <el-table-column prop="product_count" align="center" label="商品数量" min-width="120">
                            <template slot-scope="scope">
                                <span>{{scope.row.product_count}}{{scope.row.product_unit}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sale_total_amount" align="center" label="实付金额" min-width="120">
                        </el-table-column>
                        <el-table-column prop="product_image_url" align="center" label="商品图片" min-width="80">
                            <template slot-scope="scope">
                                <img class="cursor" :src="baseUrl + scope.row.product_image_url" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.product_image_url;dlg_preview.visible = true;" title="点击查看" />
                            </template>
                        </el-table-column>
                    </el-table>
                </el-dialog>
                <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
                    <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                baseUrl:this.$client.IMG_URL,
                body_loading:false,
                is_refresh: true,
                type:this.$route.query.type == undefined? '' : this.$route.query.type,
                order_number:this.$route.query.order_number == undefined? '' : this.$route.query.order_number,
                status:this.$route.query.status == undefined? '' : this.$route.query.status,
                currentTab:"2",
                order_mode:'',
                url:'',
                name:'',
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                },
                dlg_goods:{
                    title:'',
                    visible:false,
                    table_data:{
                        loading: false,
                        list:[]
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '点单详情';
            if(this.type==1){
                this.url = '/order/orderdeal';
                this.name = '待完成列表'
            }else {
                this.url = '/order/orderlist';
                this.name = '已完成列表'
            }
            this.getList();
        },
        methods: {
            getList() {
                var _this = this;
                var params = {order_number:this.order_number,status:this.status,type:this.currentTab};
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                this.$client.get('/adminapi/ordersub/userlist', params, function(res,message){
                    _this.table_data.list = res.list;
                    if(_this.currentTab=='2'){
                        _this.order_mode = res.list[0].order_mode;
                    }
                    _this.table_data.page_info = res.pager;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleClick(tab, event){
                //console.log(tab.name);
                var type = tab.name;
                this.currentTab = type;
                this.table_data.page_info.page = 1;
                this.getList();
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            printThis(user_number){
                var _this = this;
                var params={
                    order_number:this.order_number,
                    user_number:user_number
                };
                this.$client.post('/adminapi/order/printkitchenorder', params, function(res,message){
                    _this.$message(message);
                },function(res){

                });
            },
            goodsDetail(user_number,sub_order_number){
                var _this = this;
                var params={
                    order_number:this.order_number,
                    user_number:user_number
                };
                if(sub_order_number!=1){
                    params.sub_order_number = sub_order_number
                }
                var api = '/api/biz/order/getModelEx';
               
                this.dlg_goods.table_data.loading = true;
                this.$client.post(api, params, function(res,message){
                    _this.dlg_goods.table_data.list = res;
                    _this.dlg_goods.visible = true;
                    _this.dlg_goods.table_data.loading = false;
                },function(res){
                    _this.dlg_goods.table_data.loading = false;
                });
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .detail-tabs>.el-tabs__header{
        border-bottom: none;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .detail-tabs>.el-tabs__header .el-tabs__nav{
        border: none;
    }
    .detail-tabs>.el-tabs__header .el-tabs__item{
        border-left: none;
    }
    .detail-tabs .el-tabs__item{
        width: 120px;
        border-radius: 5px 0px 0px 5px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
        background: #C1C1C1;
        text-align: center;
        border: none;
    }
    .detail-tabs .el-tabs__item+.el-tabs__item{
        border-radius: 0px 5px 5px 0px;
    }
    .detail-tabs .el-tabs__item.is-active{
        background: #FF6D33;
        border: none;
    }
    .detail-tabs .el-tabs__nav-wrap::after{
        display: none;
    }
</style>
<style scoped>
    .status-2{
        color: #9a9a9a;
    }
    .status-1{
        color: #F31A5C;
    }
    .status-0{
        color: #F27918;
    }
    .status-3{
        color: #0C67F0;
    }
    .status-9{
        color: #04B365;
    }
    .status-10{
        color: #666;
    }
</style>